export { default as cartIcon } from './cart';
export { default as cartPageIcon } from './cart-page';
export { default as categoriesIcon } from './categories';
export { default as categoryIcon } from './category';
export { default as myAccountIcon } from './my-account';
export { default as productsIcon } from './products';
export { default as relatedProductsIcon } from './related-products';
export { default as thankYouPageIcon } from './thank-you-page';
